export const type = 'addProduct';

const addProduct = (payload) => ({
    type,
    payload: payload,
});

export default addProduct;